import { motion } from 'framer-motion';

const HomeschoolCostEffective = () => {
  return (
    <>
      <div className="relative flex flex-col items-center bg-white px-3 py-20 sm:px-10">
        <div className="w-full max-w-[480px]">
          {/*타이틀 */}
          <div className="text-center text-3xl font-bold text-[#737373] md:text-4xl">
            아무리 비교해 봐도
            <br />
            이런 가성비는 없습니다!
          </div>

          {/* 비용 비교 */}
          <div className="mt-5 grid grid-cols-2 text-center text-xs md:text-base">
            <div className="relative rounded-2xl border-4 border-[#ff9b00] bg-[#fffcf7] p-4 py-10 shadow-lg">
              <div className="rounded-full bg-[#FFE0AE] px-1 py-1 text-xs font-bold md:text-base">
                젭스영어교실 교육 비용
              </div>
              <div className="mt-2 border-b border-black pb-2 text-lg font-bold">
                베이직 1년 기준
              </div>

              <div className="mt-4 font-bold text-[#ff4c00]">
                2025년 영어교실 등록비
              </div>

              <div className="text-lg font-bold">월 120,000원</div>

              <div className="mt-2 font-semibold">*목회자 할인가 적용시</div>

              <div className="text-lg font-bold">월 100,000원</div>
              <motion.div
                className="absolute -right-5 top-2/3 -translate-y-1/2 transform"
                // style={{ paddingRight: 6 }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                <DoubleLeftArrow width={40} />
              </motion.div>
              {/* <div className="absolute -right-5 top-2/3 transform -translate-y-1/2">
                <DoubleLeftArrow width={40} />
              </div> */}
            </div>
            {/* <div className="absolute right-0 top-1/2 transform translate-x-1/2">
              <DoubleLeftArrow width={40} />
            </div> */}

            <div className="my-auto h-fit rounded-r-2xl bg-gray2 px-1 py-7 shadow-lg sm:px-4">
              <div className="mx-auto w-fit rounded-full bg-gray8 px-3 py-1 text-xs font-bold text-white md:text-base">
                초등학생 평균 영어 사교육비
              </div>
              <div className="mt-2 border-b border-black pb-2 text-lg font-bold">
                일반 학원비 기준
              </div>

              <div className="mt-4 font-semibold">
                초등학생{' '}
                <span className="font-bold text-[#FF9B00]">전체 사교육비</span>
              </div>

              <div className="text-lg font-bold">월 398,000원</div>

              <div className="mt-2 font-semibold">
                초등학생{' '}
                <span className="font-bold text-[#FF4F00]">영어 사교육비</span>
              </div>

              <div className="text-lg font-bold">월 248,000원</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DoubleLeftArrow = ({ width }: { width: number }) => (
  <svg width={width} viewBox="0 0 72 72" fill="none">
    <defs>
      <path
        id="left-arrow"
        d="M36 53.1957L20.4566 37L36 20.913L32.3242 17L13 37L32.3242 57L36 53.1957Z"
        fill="white"
      />
    </defs>
    <circle cx="36" cy="36" r="36" fill="#FF9B00" />
    <g clipPath="url(#clip1_1_2)">
      <use href="#left-arrow" />
    </g>
    <g clipPath="url(#clip1_1_2)" transform="translate(15,0)" opacity={0.5}>
      <use href="#left-arrow" />
    </g>
  </svg>
);

export default HomeschoolCostEffective;
